import React, { useEffect } from 'react';
import { Button } from './Button';

export function Dialog({
  open,
  onClose,
  title,
  children,
  footer,
  size = 'md',
  className = '',
}) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="ds-dialog" role="presentation" onClick={onClose}>
      <div
        className={`ds-dialog__panel ds-dialog__panel--${size} ${className}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? 'ds-dialog-title' : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        {title ? (
          <h2 id="ds-dialog-title" className="ds-dialog__title">
            {title}
          </h2>
        ) : null}
        <div className="ds-dialog__body">{children}</div>
        {footer ? <div className="ds-dialog__footer">{footer}</div> : null}
      </div>
    </div>
  );
}

export function DialogActions({ onCancel, onConfirm, cancelLabel = 'Cancelar', confirmLabel = 'Confirmar', confirmDisabled = false }) {
  return (
    <>
      <Button variant="outline" onClick={onCancel}>
        {cancelLabel}
      </Button>
      <Button variant="solid" onClick={onConfirm} disabled={confirmDisabled}>
        {confirmLabel}
      </Button>
    </>
  );
}

export default Dialog;
